import React from "react"
import { useContent } from "@thoughtbot/superglue"

import { DeveloperDocsLayout, type DeveloperDocsPage } from "@javascript/components/developer-docs/DeveloperDocsLayout"
import { StylingAndAssetsPage } from "@javascript/components/developer-docs/StylingAndAssetsPage"

interface StylingAndAssetsContent {
  pages: DeveloperDocsPage[]
  assetReferenceExample: string
}

export default function StylingAndAssets() {
  const { pages, assetReferenceExample } = useContent<StylingAndAssetsContent>()

  return (
    <DeveloperDocsLayout pages={pages} currentHref="/developers/styling-and-assets">
      <StylingAndAssetsPage assetReferenceExample={assetReferenceExample} />
    </DeveloperDocsLayout>
  )
}
